/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
export interface TypedEventEmitter<T> {
  on<K extends keyof T>(name: K, listener: (v: T[K]) => void): this;
  once<K extends keyof T>(event: K, listener: (v: T[K]) => void): this;
  off<K extends keyof T>(event: K, listener: (v: T[K]) => void): this;
  listeners<K extends keyof T>(event: K): (v: T[K]) => void[];
  emit<K extends keyof T>(event: K, args: T[K]): boolean;
  eventNames<K extends keyof T>(): Array<K>;
}

interface MyEvents {
  moduleLoaded: void;
}

type Listener = (...args: any[]) => void;
interface Events {
  [event: string]: Listener[];
}

export default new (class EventEmitter {
  private _events: Events = {};

  public get events() {
    return this._events;
  }

  public on(event, listener) {
    if (this._events[event] === undefined) this._events[event] = [];

    this._events[event].push(listener);

    return () => {
      this.off(event, listener);
    };
  }

  public off(event?: string, listener?: Listener) {
    if (event === undefined && listener === undefined) {
      this._events = {};
    } else if (listener === undefined && event) {
      delete this._events[event];
    } else if (
      event &&
      listener &&
      this._events[event].indexOf(listener) !== -1
    ) {
      this._events[event].splice(this._events[event].indexOf(listener), 1);
    }
  }

  public emit(event: string, ...args: any[]) {
    if (this._events[event] !== undefined) {
      for (const listener of this._events[event]) {
        listener(...args);
      }
    }

    if (event !== '*') this.emit('*', ...args);
  }

  public once(event: string, listener: Listener) {
    return this.on(event, () => {
      this.emit(event);

      this.off(event, listener);
    });
  }
})();
